import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { zIndex, colors, rem, getResetByTag, breakpoints } from '../../styles';
import StyledModalContent from './styles/modal.content.styles';
import StyledModalContentContainer from './styles/modal.content-container.styles';
import StyledModalBody from './components/modal-body/modal.body.styles';
import StyledOverlay from '../overlay/overlay.styles';
var modalDefaultStyles = function modalDefaultStyles() {
  return /*#__PURE__*/css("background-color:", colors.blackDeep, ";color:", colors.black, ";position:relative;text-align:left;z-index:", zIndex.zIndex_12, ";", StyledOverlay, "{overflow:auto;width:100%;z-index:", zIndex.zIndex_11, ";}@media (max-height: 400px){", StyledModalContentContainer, "{max-height:none;overflow-y:scroll;}@media (min-width: ", rem(breakpoints.md[0]), "){", StyledModalContent, "{margin:0 auto;max-height:calc(100vh - ", rem(50), ");}}", StyledModalBody, "{max-height:none;overflow-y:initial;}}" + (process.env.NODE_ENV === "production" ? "" : ";label:modalDefaultStyles;"));
};
var sizeStyles = function sizeStyles(_ref) {
  var size = _ref.size;
  switch (size) {
    case 'xs':
      return /*#__PURE__*/css("@media (min-width: ", rem(breakpoints.md[0]), "){", StyledModalContent, "{max-width:", rem(344), ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:sizeStyles;"));
    case 'sm':
      return /*#__PURE__*/css("@media (min-width: ", rem(breakpoints.md[0]), "){", StyledModalContent, "{max-width:", rem(544), ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:sizeStyles;"));
    case 'lg':
      return /*#__PURE__*/css("@media (min-width: ", rem(breakpoints.md[0]), "){", StyledModalContent, "{max-width:", rem(824), ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:sizeStyles;"));
    case 'xl':
      return /*#__PURE__*/css("@media (min-width: ", rem(breakpoints.md[0]), "){", StyledModalContent, "{max-width:", rem(1024), ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:sizeStyles;"));
  }
};
var resetStyles = getResetByTag('div');
var StyledModal = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e13nx2dw0"
} : {
  target: "e13nx2dw0",
  label: "StyledModal"
})(resetStyles, modalDefaultStyles, sizeStyles);
export default StyledModal;